import React, { useState, useEffect, useRef } from "react";
import ChequeImageViewer from "./cheque-image-viewer";
import SecurePDFViewer from "./secure-pdf-viewer";
import { Row, Col } from "react-flexbox-grid";
import { Button } from "react-md";
import { SelectField } from "react-md";
import {
  TextField,
  InputAdornment,
  MenuItem,
  Menu,
  IconButton,
  InputLabel,
  FormControl,
  Box,
  Checkbox,
  FormControlLabel,
  Select,
  OutlinedInput,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { ArrowForward, CheckCircle } from "@material-ui/icons";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { CircularProgress } from "react-md";
import BankAccountService from "../../../../../ops/modules/patients/modules/new-bridge/services/BankAccountService";
import EventService from "../../../../../../service/event/EventService";
import { errorMessageHandler } from "../../../disqualification-module/utils/helperMethod";

const AddBankAccount = ({
  handleCloseModal,
  operation,
  setOpenBankAccountAddDialog,
  menuFor,
  callback,
  onSuccessfullSaveCallback,
}) => {
  const [bankAccountForm, setBankAccountForm] = useState(null);
  const [showAccountNum, setShowAccountNum] = useState(false);
  const [showAccountNumReEntered, setShowAccountNumReEntered] = useState(false);
  const [fetchIFSCDetailsResponse, setFetchIFSCDetailsResponse] =
    useState(null);
  const uploadDocumentRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [ifscLoading, setIfscLoading] = useState(false);
  const [documentDataWithStatus, setDocumentDataWithStatus] = useState([]);
  const bankAccountService = new BankAccountService();
  const openDocumentInNewTab = (url) => {
    window.open(url, "_blank");
  };

  const ACCOUNT_TYPE_MAP = {
    1: "Savings",
  };
  const ACCOUNT_TYPE_OPTIONS = [
    {
      label: "Savings",
      value: 1,
    },
  ];

  const BANK_ACCOUNT_VERIFICATION_STATUS_VERIFIED = 1;
  const BANK_ACCOUNT_VERIFICATION_STATUS_UNVERIFIED = 0;
  const BANK_ACCOUNT_VERIFICATION_STATUS_REJECTED = 2;

  const handleAddBankAccount = (bankAccountForm) => {
    if (bankAccountForm?.accountNum !== bankAccountForm?.accountNumReEntered) {
      EventService.emit("showError", {
        message: "Account number and confirmed account number should be same",
      });
      return false;
    }

    let formDataRequest = new FormData();

    formDataRequest.append(
      "cancelledCheque",
      documentDataWithStatus[0]?.fileObject
    );
    formDataRequest.append(
      "accountHolderName",
      bankAccountForm?.accountHolderName
    );
    formDataRequest.append("accountNum", bankAccountForm?.accountNum);
    formDataRequest.append("ifsc", bankAccountForm?.ifsc);
    formDataRequest.append("accountType", bankAccountForm?.accountType);
    formDataRequest.append("patientId", menuFor?.patientId);

    setLoading(true);
    bankAccountService.addBankAccount(
      formDataRequest,
      (res) => {
        EventService.emit("showError", {
          message: "Bank account saved successfully!",
        });
        setLoading(false);
        // if (callback) {
        //   callback();
        // }
        if (onSuccessfullSaveCallback) {
          onSuccessfullSaveCallback();
        }
      },
      (err) => {
        EventService.emit("showError", {
          message: errorMessageHandler(err).toString(),
        });
        setLoading(false);
      }
    );
  };

  const isBranchDetailsValid = (fetchIFSCDetailsResponse) => {
    if (
      fetchIFSCDetailsResponse?.bankName &&
      fetchIFSCDetailsResponse?.branchName &&
      fetchIFSCDetailsResponse?.address
    ) {
      return true;
    }
    return false;
  };

  const isZeroObjectId = (objId) => {
    const objectId = (objId ?? "").toString();
    if (!objectId) {
      return true;
    }
    if (objectId === "" || objectId === "000000000000000000000000") {
      return true;
    }
    return false;
  };

  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

  const validateIfsc = (value) => {
    if (ifscRegex.test(value)) {
      return true;
    } else {
      return false;
    }
  };

  const fetchIFSCDetails = (ifsc) => {
    setLoading(true);
    setIfscLoading(true);
    bankAccountService.fetchIFSCDetails(
      ifsc,
      (res) => {
        setFetchIFSCDetailsResponse(res);
        setLoading(false);
        setIfscLoading(false);
      },
      (err) => {
        EventService.emit("showError", {
          message:
            "Error fetching ifsc details : err : " +
            errorMessageHandler(err).toString(),
        });
        setLoading(false);
        setIfscLoading(false);
      }
    );
  };

  const handleUploadDocumentClick = () => {
    if (uploadDocumentRef && uploadDocumentRef.current) {
      uploadDocumentRef.current.click();
    }
  };

  const removeDocument = (event, index) => {
    event.stopPropagation();
    const docToRemove = documentDataWithStatus[index];
    // URL.revokeObjectURL(docToRemove.url);
    setDocumentDataWithStatus((prevDocs) =>
      prevDocs.filter((_, i) => i !== index)
    );
  };

  const handleDocFileInput = (event) => {
    const files = Array.from(event.target.files);
    if (documentDataWithStatus.length + files.length > 5) {
      alert("You can upload a maximum of 5 files.");
      return;
    }

    const newFiles = files.reduce((acc, file) => {
      if (file.size > 20000000) {
        alert(`File "${file.name}" is too large. Max allowed size is 20 MB.`);
      } else {
        acc.push({
          name: file.name,
          status: "selected",
          url: URL.createObjectURL(file),
          fileObject: file,
        });
      }

      return acc;
    }, []);

    setDocumentDataWithStatus((prevDocs) => [...prevDocs, ...newFiles]);
    event.target.value = null;
  };

  const isAddBankAccountFormValid = (bankAccountForm) => {
    if (
      !(
        isBranchDetailsValid(fetchIFSCDetailsResponse) &&
        bankAccountForm?.accountHolderName &&
        bankAccountForm?.accountType &&
        bankAccountForm?.accountNum &&
        bankAccountForm?.accountNumReEntered &&
        bankAccountForm?.ifsc &&
        (documentDataWithStatus?.length ?? 0) > 0
      )
    ) {
      return false;
    }

    return true;
  };

  return (
    <div
      style={{ width: "600px", left: "20%" }}
      className="custom-modal-content scrollable-modal-full-height"
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            fontSize: "24px",
            fontWeight: 700,
            fontFamily: "Montserrat",
            textAlign: "center",
          }}
        >
          {operation === "add"
            ? "Add bank account"
            : operation === "update"
            ? "Bank account"
            : ""}
        </div>

        <IconButton onClick={handleCloseModal}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </div>

      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "32px",
            width: "100%",
          }}
        >
          <TextField
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            label="Full name as per bank account"
            required
            placeholder="Full name as per bank account"
            value={bankAccountForm?.accountHolderName ?? ""}
            onChange={(event) => {
              const newValue = event.target.value;
              // Regex to remove any characters that are NOT in the a-z or A-Z range
              const alphaOnly = newValue
                .replace(/[^a-zA-Z ]/g, "")
                .substring(0, 100);

              setBankAccountForm((prev) => ({
                ...prev,
                accountHolderName: alphaOnly,
              }));
            }}
            disabled={loading || ifscLoading}
          />

          <div style={{ height: "16px" }}></div>

          <FormControl variant="outlined" fullWidth>
            <InputLabel
              id="demo-label"
              shrink
              style={{ backgroundColor: "#fff", padding: "0 6px" }}
            >
              Account type
            </InputLabel>
            <Select
              labelId="demo-label"
              value={bankAccountForm?.accountType}
              onChange={(e) => {
                if (e) {
                  setBankAccountForm((prev) => ({
                    ...prev,
                    accountType: e.target.value,
                  }));
                }
              }}
              input={<OutlinedInput label="Account type" />}
            >
              {(ACCOUNT_TYPE_OPTIONS ?? []).map((elem, idx) => (
                <MenuItem key={idx} value={elem?.value}>
                  {elem?.label ?? ""}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <div style={{ height: "16px" }}></div>

          <TextField
            variant="outlined"
            type={showAccountNum ? "text" : "password"}
            InputLabelProps={{ shrink: true }}
            placeholder="Bank account number"
            required
            label="Bank account number"
            value={bankAccountForm?.accountNum ?? ""}
            disabled={loading || ifscLoading}
            onChange={(event) => {
              const newValue = event.target.value
                .replace(/\D/g, "")
                .substring(0, 20);
              setBankAccountForm((prev) => ({
                ...prev,
                accountNum: newValue,
              }));
            }}
            InputProps={
              !Boolean(bankAccountForm?.accountNum)
                ? {}
                : {
                    endAdornment: (
                      <InputAdornment position="end">
                        {Boolean(showAccountNum) ? (
                          <IconButton
                            onClick={(e) => {
                              setShowAccountNum((prev) => !prev);
                            }}
                          >
                            <Visibility />
                          </IconButton>
                        ) : (
                          <IconButton
                            onClick={(e) => {
                              setShowAccountNum((prev) => !prev);
                            }}
                          >
                            <VisibilityOff />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }
            }
          />
          <div style={{ height: "16px" }}></div>
          <TextField
            variant="outlined"
            type={showAccountNumReEntered ? "text" : "password"}
            InputLabelProps={{ shrink: true }}
            placeholder="Confirm Bank account number"
            required
            onChange={(event) => {
              const newValue = event.target.value
                .replace(/\D/g, "")
                .substring(
                  0,
                  Math.min(
                    20,
                    Math.max(1, (bankAccountForm?.accountNum ?? "").length)
                  )
                );
              setBankAccountForm((prev) => ({
                ...prev,
                accountNumReEntered: newValue,
              }));
            }}
            label="Confirm Bank account number"
            value={bankAccountForm?.accountNumReEntered ?? ""}
            disabled={
              loading ||
              ifscLoading ||
              (bankAccountForm?.accountNum ?? "").length <= 0
            }
            InputProps={
              !Boolean(bankAccountForm?.accountNumReEntered)
                ? {}
                : {
                    endAdornment: (
                      <InputAdornment position="end">
                        {Boolean(showAccountNumReEntered) ? (
                          <IconButton
                            onClick={(e) => {
                              setShowAccountNumReEntered((prev) => !prev);
                            }}
                          >
                            <Visibility />
                          </IconButton>
                        ) : (
                          <IconButton
                            onClick={(e) => {
                              setShowAccountNumReEntered((prev) => !prev);
                            }}
                          >
                            <VisibilityOff />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }
            }
          />
          <div style={{ height: "16px" }}></div>
          <TextField
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            placeholder="IFSC code"
            onChange={(event) => {
              const newValue = event.target.value;
              if ((newValue ?? "").length > 11) {
                return;
              }
              setBankAccountForm((prev) => ({
                ...prev,
                ifsc: newValue.toUpperCase(),
              }));
              setFetchIFSCDetailsResponse((prev) => null);
            }}
            required
            label="IFSC code"
            value={bankAccountForm?.ifsc ?? ""}
            disabled={loading || ifscLoading}
            InputProps={
              !Boolean(bankAccountForm?.ifsc)
                ? {}
                : {
                    endAdornment: (
                      <InputAdornment position="end">
                        {Boolean(ifscLoading) ? (
                          <CircularProgress style={{ color: "orange" }} />
                        ) : Boolean(
                            isBranchDetailsValid(fetchIFSCDetailsResponse)
                          ) ? (
                          <IconButton>
                            <CheckCircle style={{ color: "#1BC47D" }} />
                          </IconButton>
                        ) : (
                          <IconButton
                            disabled={!validateIfsc(bankAccountForm?.ifsc)}
                            onClick={(e) => {
                              fetchIFSCDetails(bankAccountForm?.ifsc);
                            }}
                          >
                            <ArrowForward
                              style={{
                                color: validateIfsc(bankAccountForm?.ifsc)
                                  ? "orange"
                                  : "#CED4DA",
                              }}
                            />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }
            }
          />
          {Boolean(isBranchDetailsValid(fetchIFSCDetailsResponse)) && (
            <>
              <div style={{ height: "16px" }}></div>
              <TextField
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                placeholder="Bank name"
                label="Bank name"
                value={fetchIFSCDetailsResponse?.bankName ?? ""}
                disabled={true}
              />
              <div style={{ height: "16px" }}></div>
              <TextField
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                placeholder="Branch name"
                label="Branch name"
                value={fetchIFSCDetailsResponse?.branchName ?? ""}
                disabled={true}
              />
              <div style={{ height: "16px" }}></div>
              <TextField
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                placeholder="Branch address"
                label="Branch address"
                value={fetchIFSCDetailsResponse?.address ?? ""}
                disabled={true}
              />
            </>
          )}

          <div style={{ height: "24px" }}></div>

          {
            <>
              {documentDataWithStatus.map((doc, index) => (
                <>
                  <h4 style={{ marginTop: "25px", marginBottom: "15px" }}>
                    Cancelled cheque
                  </h4>
                  <div
                    key={index}
                    className={
                      doc.status == "error"
                        ? "document-box-div-error"
                        : "document-box-div"
                    }
                    onClick={() => {
                      if (loading || ifscLoading) {
                        return;
                      }
                      openDocumentInNewTab(doc.url);
                    }}
                  >
                    <div
                      style={{
                        fontSize: 14,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {" "}
                      {doc.name}
                    </div>
                    {doc.status == "uploading" && (
                      <CircularProgress style={{ margin: 0 }} />
                    )}
                    {(doc.status == "selected" || doc.status == "error") && (
                      <button
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          width: "24px",
                          height: "24px",
                          borderRadius: "70%",
                          backgroundColor: "#fff",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "#333",
                          fontWeight: "bold",
                          fontSize: "17px",
                        }}
                        onClick={(event) => {
                          if (loading || ifscLoading) {
                            return;
                          }
                          removeDocument(event, index);
                        }}
                      >
                        &times;
                      </button>
                    )}

                    {doc.status == "uploaded" && (
                      <CheckCircle color="#1BC47D" />
                    )}
                  </div>
                </>
              ))}

              <input
                type="file"
                hidden
                multiple={false}
                accept={"application/pdf,image/png,image/jpeg,image/jpg"}
                ref={uploadDocumentRef}
                onChange={handleDocFileInput}
              />
            </>
          }

          {documentDataWithStatus?.length <= 0 && (
            <div
              style={{
                marginTop: "25px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ fontSize: "12px", fontWeight: 500 }}>
                (Max size 20 MB)
              </div>
            </div>
          )}

          <Button
            fullWidth
            variant="contained"
            onClick={(e) => {
              if ((documentDataWithStatus?.length ?? 0) <= 0) {
                handleUploadDocumentClick();
              } else {
                handleAddBankAccount(bankAccountForm);
              }
            }}
            className="full-width-button"
            disabled={
              loading ||
              ifscLoading ||
              // check below in case of save
              (documentDataWithStatus.length > 0 &&
                !isAddBankAccountFormValid(bankAccountForm))
            }
            style={{
              backgroundColor:
                loading ||
                ifscLoading ||
                // check below in case of save
                (documentDataWithStatus.length > 0 &&
                  !isAddBankAccountFormValid(bankAccountForm))
                  ? "#e0e0e0"
                  : "#f57c00",
              color: "#fff",
              marginTop: "20px",
            }}
          >
            {documentDataWithStatus.length > 0
              ? "Save"
              : "Upload cancelled cheque"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddBankAccount;
